import React, { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  IconButton,
  Typography,
  Box,
  DialogContent,
  Tabs,
  Tab,
  Grid,
  Divider
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Avatar } from "@mui/material";
import { IMAGE_URL } from "../../services/api";
import ProtectedImage from "../../components/ProtectedImage";



const AppraisalViewModal = ({ show, handleClose, selectedCycle }) => {
  const [tabValue, setTabValue] = useState(0);
  // const BASE_URL = "http://localhost:8000";

  const handleTabChange = (_, newValue) => setTabValue(newValue);

  const chunkArray = (arr, size) => {
  const result = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
};

useEffect(() => {
  if (show) {
    setTabValue(0); // always reset to first tab
  }
}, [show]);


  const detailRow = (label, value) => (
    <Grid container spacing={1} sx={{ mb: 1 }}>
      <Grid item xs={6}>
        <Typography variant="body2" fontWeight="bold">
          {label}
        </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography variant="body2" color="text.secondary">
          {value || "N/A"}
        </Typography>
      </Grid>
    </Grid>
  );

  return (
    <Dialog
      open={show}
      onClose={handleClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          height: "100vh",
          width: "100vw",
          maxWidth: "none",
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      {/* Header */}
      <DialogTitle sx={{ p: 0 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            p: 2,
            borderBottom: "1px solid #ccc",
          }}
        >
          {selectedCycle?.profile_image ? (
            <ProtectedImage
  path={
    selectedCycle.profile_image.startsWith("data:")
      ? selectedCycle.profile_image
      : `${IMAGE_URL}${selectedCycle.profile_image}`
  }
  alt="Profile"
  style={{
    width: "56px",
    height: "56px",
    borderRadius: "50%",
    objectFit: "cover",
  }}
/>

          ) : (
            <Box
              sx={{
                width: 56,
                height: 56,
                borderRadius: "50%",
                backgroundColor: "#1976d2",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                color: "#fff",
                fontWeight: "bold",
                fontSize: 20,
                textTransform: "uppercase",
              }}
            >
              {selectedCycle?.employee_name?.split(" ")[0]?.[0]}
              {selectedCycle?.employee_name?.split(" ")[1]?.[0]}
            </Box>
          )}

          <Box sx={{ ml: 2 }}>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                flexWrap: "wrap",
              }}
            >
              <Typography variant="h6" fontWeight="bold">
                {selectedCycle?.employee_name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                ({selectedCycle?.employee_id || "N/A"})
              </Typography>
              <Box
                sx={{
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  backgroundColor: selectedCycle?.is_active ? "#00cc00" : "red",
                  ml: 0.5,
                }}
              />
            </Box>
            <Typography variant="body2" color="text.secondary">
              {selectedCycle?.designation || "N/A"}
            </Typography>
          </Box>

          <Box sx={{ flexGrow: 1 }} />
          <IconButton onClick={handleClose}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      {/* Tabs */}
      <Tabs value={tabValue} onChange={handleTabChange} sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tab label="Appraisal Details" />
        <Tab label="Reviewers Details" />
      </Tabs>

      <DialogContent sx={{ flex: 1, overflowY: "auto" }}>
        {tabValue === 0 && (
          <Box sx={{ mt: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={6}>{detailRow("Cycle Start", selectedCycle?.cycle_start)}</Grid>
              <Grid item xs={6}>{detailRow("Cycle End", selectedCycle?.cycle_end)}</Grid>
              <Grid item xs={6}>{detailRow("Old Salary", selectedCycle?.old_salary)}</Grid>
              <Grid item xs={6}>{detailRow("Hike (%)", selectedCycle?.hike_percentage)}</Grid>
              <Grid item xs={6}>{detailRow("New Salary", selectedCycle?.new_salary)}</Grid>
              <Grid item xs={6}>{detailRow("Effective From", selectedCycle?.effective_from)}</Grid>
              <Grid item xs={6}>{detailRow("Average Rating", selectedCycle?.average_rating)}</Grid>
              <Grid item xs={6}>{detailRow("Status", selectedCycle?.status)}</Grid>
            </Grid>
          </Box>
        )}

{tabValue === 1 && (
  <Box sx={{ mt: 2 }}>
    {selectedCycle?.reviewers_details?.length ? (
      chunkArray(selectedCycle.reviewers_details, 2).map((row, rowIndex) => (
        <Grid container spacing={2} key={rowIndex} sx={{ mb: 2 }}>
          {row.map((rev, index) => (
            <Grid item xs={6} key={index}>
              <Box sx={{ display: "flex", flexDirection: "column", border: "1px solid #ddd", borderRadius: 2, p: 1.5 }}>
                
                {/* Top Section: Image + Name + ID + Status + Designation */}
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  {rev.profile_image ? (
                    <ProtectedImage
  path={
    rev.profile_image.startsWith("data:")
      ? rev.profile_image
      : `${IMAGE_URL}${rev.profile_image}`
  }
  alt={rev.employee_name}
  style={{
    width: "56px",
    height: "56px",
    borderRadius: "50%",
    objectFit: "cover",
  }}
/>

                  ) : (
                    <Box
                      sx={{
                        width: 56,
                        height: 56,
                        borderRadius: "50%",
                        backgroundColor: "#1976d2",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#fff",
                        fontWeight: "bold",
                        fontSize: 20,
                        textTransform: "uppercase",
                      }}
                    >
                      {rev.employee_name?.split(" ")[0]?.[0]}
                      {rev.employee_name?.split(" ")[1]?.[0]}
                    </Box>
                  )}

                  <Box sx={{ ml: 2 }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
                      <Typography variant="subtitle1" fontWeight="bold">
                        {rev.employee_name}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        ({rev.employee_id || "N/A"})
                      </Typography>
                      <Box
                        sx={{
                          width: 10,
                          height: 10,
                          borderRadius: "50%",
                          backgroundColor: rev.is_active ? "#00cc00" : "red",
                        }}
                      />
                    </Box>
                    <Typography variant="body2" color="text.secondary">
                      {rev.designation || "N/A"}
                    </Typography>
                  </Box>
                </Box>

                {/* Bottom Section: Rating, Date, Comment */}
                <Box sx={{ mt: 1.5 }}>
                  <Typography variant="body2">
                    <strong>Rating:</strong> {rev.rating || "N/A"}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    <strong> Rating Date:</strong> {rev.review_date || "N/A"}
                  </Typography>
                  {rev.comments && (
                    <Typography variant="body2" sx={{ mt: 0.5 }}>
                      <strong>Comment:</strong> {rev.comments}
                    </Typography>
                  )}
                </Box>

              </Box>
            </Grid>
          ))}
        </Grid>
      ))
    ) : (
      <Typography variant="body2" color="text.secondary">
        No reviewers
      </Typography>
    )}
  </Box>
)}

      </DialogContent>
    </Dialog>
  );
};

export default AppraisalViewModal;
